// 产品信息 api

import { isNull } from "@/utils/fangerUtils";
import { axiosPost } from "@/utils/request";

/**
 * 查询
 * @param {*} params
 * @returns
 */
export const listProduct = (params) => {
  let sort = [
    { column: "productName", querLogic: "DESC" },
    { column: "operateTime", querLogic: "DESC" },
  ];
  if (params !== undefined) {
    if ("sort" in params) {
      sort = sort.concat(JSON.parse(params.sort));
    }
    params.sort = JSON.stringify(sort);
  }

  return axiosPost({
    url: "/warehouseProduct/selectWarehouseProduct",
    data: params,
  });
};

/**
 * 新增
 * @param {*} params
 * @returns
 */
export const addProduct = (params) => {
  return axiosPost({
    url: "/warehouseProduct/insertWarehouseProduct",
    data: params,
    tips: true,
  });
};

/**
 * 修改
 * @param {*} params
 * @returns
 */
export const updateProduct = (params) => {
  return axiosPost({
    url: "/warehouseProduct/updateWarehouseProduct",
    data: params,
    tips: true,
  });
};

/**
 * 删除
 * @param {*} id
 * @returns
 */
export const deleteProduct = (productId) => {
  return axiosPost({
    url: "/warehouseProduct/deleteWarehouseProduct",
    data: {
      productId,
    },
    tips: true,
  });
};
/**
 * 删除图片
 * @param {*} id
 * @returns
 */
export const deleteFile = (data) => {
  return axiosPost({
    url: "/cos/deleteFile",
    data: data,
    tips: true,
  });
};
